import { ThemeOptions } from '@mui/material/styles/createTheme';

import { tokens } from '../../theme/generated/tokens';

export const previewMarkdownTheme: ThemeOptions['components'] = {
  DsPreviewMarkdown: {
    styleOverrides: {
      root: {
        color: tokens.theme.fg.structural.primary,
        '& > *:last-child': {
          marginBottom: 0,
        },
      },
      h1: ({ theme }) => ({
        ...theme.typography.h1,
        marginBottom: '20px',
        marginTop: 0,
      }),
      h2: ({ theme }) => ({
        ...theme.typography.h2,
        marginTop: 0,
        marginBottom: '16px',
      }),
      h3: ({ theme }) => ({
        ...theme.typography.h3,
        marginTop: 0,
        marginBottom: '12px',
      }),
      h4: ({ theme }) => ({
        ...theme.typography.h4,
        marginTop: 0,
        marginBottom: '8px',
      }),
      h5: ({ theme }) => ({
        ...theme.typography.h5,
        marginTop: 0,
        marginBottom: '4px',
      }),
      strong: ({ theme }) => ({
        ...theme.typography.L12B,
        marginTop: 0,
        marginBottom: '12px',
      }),
      p: ({ theme }) => ({
        ...theme.typography.P12R,
        marginTop: 0,
        marginBottom: '8px',
      }),
      ol: ({ theme }) => ({
        ...theme.typography.P12R,
        marginTop: 0,
        marginBottom: '8px',
        paddingInlineStart: '20px',
      }),
      ul: ({ theme }) => ({
        ...theme.typography.P12R,
        marginTop: 0,
        marginBottom: '8px',
        paddingInlineStart: '20px',
      }),
      blockquote: ({ theme }) => ({
        ...theme.typography.P12R,
        color: tokens.theme.fg.structural.secondary,
        borderLeft: `1px solid ${tokens.theme.border.structural.neutralStrong}`,
        paddingInlineStart: '12px',
        marginInlineStart: 0,
        marginInlineEnd: 0,
      }),
      code: ({ theme }) => ({
        ...theme.typography.C12,
        backgroundColor: tokens.theme.bg.structural.code,
        color: tokens.theme.fg.structural.primaryOnInverse,
        padding: '8px 12px',
        borderRadius: tokens.theme.radius.sm,
        whiteSpace: 'break-spaces',
      }),
      codeInline: ({ theme }) => ({
        ...theme.typography.C12,
        display: 'inline-block',
        lineHeight: '14px',
        backgroundColor: tokens.theme.readonly.bg,
        border: `1px solid ${tokens.theme.border.structural.neutral}`,
        color: tokens.theme.fg.categorical.onGreySubtle,
        padding: '0px 2px',
        borderRadius: tokens.theme.radius.xs,
        whiteSpace: 'break-spaces',
      }),
      divider: {
        margin: '4px 0px',
      },
      link: ({ theme }) => ({
        ...theme.typography.P12R,
        color: tokens.theme.fg.action.primary,
        whiteSpace: 'unset',
        textDecoration: 'none',

        '&:hover': {
          textDecoration: 'underline',
        },
      }),
    },
  },
};
